import { useIntl } from "react-intl";

import FaqAccordions from "@/patterns/wpl/faq-accordions/src/index";
import type { Feature } from "@/patterns/wpl/faq-accordions/src/index";
import { PlanAdditionalDetails } from "@/utils/pricing-queries/get-pricing-content-gql";

import { parseHtmlString } from "../../src/utils/parseHtmlString";
export interface FaqSectionProps {
    header?: string | undefined;
    planDetails?: PlanAdditionalDetails[] | undefined;
}

export const PricingFaq = ({ header, planDetails }: FaqSectionProps) => {
    const intl = useIntl();

    if (!planDetails) {
        return null;
    }

    const fallbackHeader = intl.formatMessage({
        id: "pricing.faq.header",
        defaultMessage: "Get more info"
    });

    const faqAccordionsFeatures: Feature[] = planDetails.map((item) => ({
        header: item.planAdditionalDetailsTitleExternal ?? "",
        content: parseHtmlString(item.planAdditionalDetails ?? undefined)
    }));

    return (
        <FaqAccordions
            header={header ?? fallbackHeader}
            features={faqAccordionsFeatures}
        />
    );
};

PricingFaq.displayName = "PricingFaq";
